import type { PurchaseOrder } from "@shared/types";
import { CellContext } from "@tanstack/react-table";
import { readableBatchId } from "@client-shared/lib/util";
import { cn } from "@bcc/lib/utils";
import { DataTableEmptyCell } from "@bcc/components/data-table";
import { CELL_LINK_CLASSES } from "../constants";

interface OrderBatchCellProps extends CellContext<PurchaseOrder, unknown> {
  onBatchClick?: (batchId: string) => void;
}

export const OrderBatchCell = (props: OrderBatchCellProps) => {
  const batchId = props.row.original.batchId;

  if (!batchId) return <DataTableEmptyCell />;

  return (
    <button
      type="button"
      className={cn("font-mono text-sm cursor-pointer bg-transparent border-none p-0", CELL_LINK_CLASSES)}
      onClick={(e) => {
        e.stopPropagation();
        props.onBatchClick?.(batchId);
      }}
    >
      BATCH-{readableBatchId(batchId)}
    </button>
  );
};
